import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

import { TEACHER_SESSION_KEY } from "../../../Definition";
import {
  // ホームはリニューアル予定なのでコメントアウト
  // homePath,
  selectTextbookPath,
  selectDataPath,
  textbookPath,
  chooseTextbookPath,
  activeLearningTextbookPath,
  activeLearningClassDataPath,
  classDataPath,
  projectionPath,
  assessmentDescriptionPath,
  assessmentPath,
  activeLearningProjectionPath,
  videoLessonPath,
  manualPath,
} from "../../../teacherStore";
import useAppOrderStatus from "../../../hooks/useAppOrderStatus";
import { isAvailablePartItemCodes } from "../../../libs/ActiveLearning";
// import { ReactComponent as HomeIcon } from "../../../assets/svg/home-menu_2.svg";
import { ReactComponent as BookIcon } from "../../../assets/svg/book_2.svg";
import { ReactComponent as SupportToolIcon } from "../../../assets/svg/support_tool.svg";
import { ReactComponent as AboutLoungeIcon } from "../../../assets/svg/about_lounge.svg";
import { ReactComponent as LessonDataIcon } from "../../../assets/svg/lesson_data.svg";
import { ReactComponent as StudentDataIcon } from "../../../assets/svg/class-data_2.svg";
import { ReactComponent as AssessmentIcon } from "../../../assets/svg/assessment_2.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/svg/logout_2.svg";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/svg/arrow_left_2.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/svg/arrow_right_2.svg";
import { ReactComponent as CautionIcon } from "../../../assets/svg/caution.svg";
import Modal from "../../../atoms/Modal";
import StudentLoginQrCodeModal from "../../../molecules/StudentLoginQrCodeModal";

import styles from "./LoginHeader.module.scss";

export interface LoginHeaderProps {
  isOnlyAssessment: boolean;
  availableItemCodes: string[];
  logout: () => void;
  educationGoal: string;
}

export const LoginHeader = (props: LoginHeaderProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [
    showStudentLoginQrCodeModal,
    setShowStudentLoginQrCodeModal,
  ] = useState(false);
  const { hasOnlyDlpOrder } = useAppOrderStatus();
  const { pathname } = useLocation();
  const extra = sessionStorage.getItem(TEACHER_SESSION_KEY)
    ? `?session_id=${sessionStorage.getItem(TEACHER_SESSION_KEY)}`
    : "";

  const activePath = (...args: string[]) =>
    clsx(args.some(compare => pathname.includes(compare)) && styles.active);

  const shouldHideHeader = [
    projectionPath,
    videoLessonPath,
    activeLearningProjectionPath,
  ].some(path => pathname.includes(path));

  if (shouldHideHeader) return null;

  return (
    <div
      className={clsx(
        styles.container,
        isCollapsed && styles.collapsed,
        props.isOnlyAssessment && styles.fullHeight,
      )}
    >
      <div className={styles.sidebarWrapper}>
        <nav className={styles.sidebar}>
          <div className={styles.topMenuArea}>
            <div className={styles.topSection}>
              <button
                className={styles.toggleBtn}
                onClick={() => setIsCollapsed(!isCollapsed)}
              >
                {isCollapsed ? <ArrowRightIcon /> : <ArrowLeftIcon />}
              </button>
            </div>

            <ul className={styles.menuList}>
              {!props.isOnlyAssessment && (
                <>
                  <li className={styles.labelWrapper}>
                    <p className={styles.groupLabel}>授業をする</p>
                  </li>
                  {/* <li className={activePath(homePath)}>
                      <Link aria-current="page" to={homePath}>
                        <div className={styles.iconWrapper}>
                          <HomeIcon />
                        </div>
                        <span className={styles.menuText}>HOME</span>
                      </Link>
                    </li> */}
                  <li
                    className={activePath(
                      selectTextbookPath,
                      textbookPath,
                      chooseTextbookPath,
                      activeLearningTextbookPath,
                    )}
                  >
                    <Link
                      aria-current="page"
                      to={
                        isAvailablePartItemCodes(props.availableItemCodes)
                          ? selectTextbookPath
                          : `${textbookPath}${chooseTextbookPath}`
                      }
                    >
                      <div className={styles.iconWrapper}>
                        <BookIcon />
                      </div>
                      <span className={styles.menuText}>教材</span>
                    </Link>
                  </li>
                  <li>
                    <a
                      href={`${process.env.REACT_APP_ONE_MENU_URL}/contents/support_tools${extra}`}
                    >
                      <div className={styles.iconWrapper}>
                        <SupportToolIcon />
                      </div>
                      <span className={styles.menuText}>授業補助ツール</span>
                    </a>
                  </li>
                  <li className={activePath(manualPath)}>
                    <Link aria-current="page" to={manualPath}>
                      <div className={styles.iconWrapper}>
                        <AboutLoungeIcon />
                      </div>
                      <span className={styles.menuText}>マニュアル</span>
                    </Link>
                  </li>
                  <li className={styles.labelWrapper}>
                    <p className={styles.groupLabel}>生徒の回答を見る</p>
                  </li>
                  <li>
                    <a
                      href={`${process.env.REACT_APP_ONE_MENU_URL}/class_retrospect${extra}`}
                    >
                      <div className={styles.iconWrapper}>
                        <LessonDataIcon />
                      </div>
                      <span className={styles.menuText}>授業毎データ</span>
                    </a>
                  </li>
                  <li
                    className={activePath(
                      selectDataPath,
                      classDataPath,
                      activeLearningClassDataPath,
                    )}
                  >
                    <Link
                      aria-current="page"
                      to={
                        isAvailablePartItemCodes(props.availableItemCodes)
                          ? selectDataPath
                          : classDataPath
                      }
                    >
                      <div className={styles.iconWrapper}>
                        <StudentDataIcon />
                      </div>
                      <span className={styles.menuText}>生徒個別データ</span>
                    </Link>
                  </li>
                </>
              )}
              {!hasOnlyDlpOrder && (
                <li
                  className={activePath(
                    assessmentDescriptionPath,
                    assessmentPath,
                  )}
                >
                  <Link aria-current="page" to={assessmentDescriptionPath}>
                    <div className={styles.iconWrapper}>
                      <AssessmentIcon />
                    </div>
                    <span className={styles.menuText}>自己評価データ</span>
                  </Link>
                </li>
              )}
              {props.isOnlyAssessment && (
                <li>
                  <button onClick={() => setShowLogoutModal(true)}>
                    <div className={styles.iconWrapper}>
                      <LogoutIcon />
                    </div>
                    <span className={styles.menuText}>ログアウト</span>
                  </button>
                </li>
              )}
            </ul>
          </div>

          {!props.isOnlyAssessment && (
            <div
              className={styles.qrCodeModalBox}
              onClick={() => setShowStudentLoginQrCodeModal(true)}
            >
              <CautionIcon />
              <p className={styles.qrCodeModalText}>
                {"生徒がパスワードや\nログインURLを忘れ\nた場合はこちら"}
              </p>
            </div>
          )}
        </nav>
      </div>
      {showLogoutModal && (
        <Modal
          onClose={() => setShowLogoutModal(false)}
          className={styles.modalLogout}
        >
          <div className={styles.modalLogout__title}>ログアウトしますか？</div>
          <div className={styles.modalLogout__actions}>
            <button
              className={styles.btnCancel}
              onClick={() => setShowLogoutModal(false)}
            >
              キャンセル
            </button>
            <button className={styles.btnOk} onClick={props.logout}>
              ログアウト
            </button>
          </div>
        </Modal>
      )}
      {showStudentLoginQrCodeModal && (
        <StudentLoginQrCodeModal
          onClose={() => setShowStudentLoginQrCodeModal(false)}
        />
      )}
    </div>
  );
};

export default LoginHeader;
